
// config.js
const BASE_URL = process.env.VUE_APP_API_URL || 'http://109.123.243.14/api/';
//const BASE_URL = 'http://nzidoo.test/';

export default {
  apiUrl: `${BASE_URL}api/`,
  storageUrl: `${BASE_URL}storage/`,
  downloadUrl: `${BASE_URL}public/`,
  baseurl: `${BASE_URL}`,
  accountingPercentage: 0.12,
};
